export const correctStr = val => {
  if (!val) return "";
  else return val;
};

export const correctNum = val => {
  if (!val) return 0;
  else return val;
};
